import Entity from './entity'

const TriageTask = new Entity('triagetasks')

export default TriageTask
